<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="false" :searchable="false" label="name" :loading="loading" placeholder="Выберите СНО" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">ФФД {{ scope.option.name }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">ФФД {{ scope.option.name }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import SearchSelect from "@/components/Select";

export default {
    components: {
        SearchSelect,
    },

    inheritAttrs: false,

    computed: {
        options() {
            return [
                {
                    id: "1.05",
                    name: "1.05",
                },
                {
                    id: "1.2",
                    name: "1.2",
                },
            ];
        },

        loading() {
            return false;
        },

        listeners() {
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
    },
};
</script>
